export default "__VITE_ASSET__CkpzpHnP__"